import { Avatar, Center, Grid, Paper, Text } from "@mantine/core";
import DefaultUserpic from "../../assets/default/img/anonymous_user.png";
import { useCurrentUserQuery } from "../../hooks/useCurrentUserQuery";
import { LoadOrError } from "../LoadOrError/LoadOrError";
import { useShouldShowStaffView } from "../StaffViewToggle/useShouldShowStaffView";
import { ChangePasswordForm } from "./ChangePasswordForm";
import { DevSettings } from "./DevSettings/DevSettings";
import { NotificationSettings } from "./NotificationSettings";
import { ProfilePicture } from "./ProfilePictureSettings";
import "./Settings.scss";
import { TwoFactorAuth } from "./TwoFactorAuth/TwoFactorAuth";

function Settings() {
  const { currentUser, isLoading, error } = useCurrentUserQuery();
  const { shouldShowStaffView: isStaff } = useShouldShowStaffView();

  return (
    <LoadOrError error={error} loading={isLoading}>
      {currentUser && (
        <Grid className="Settings">
          <Grid.Col span={{ base: 12, md: 4, lg: 3 }}>
            <Paper>
              <Center mb="md">
                <Avatar p="xs" size={150} src={currentUser.image}>
                  <img alt="Platzhalter für Profilbild" src={DefaultUserpic} />
                </Avatar>
              </Center>
              <Text size="lg" ta="center">
                {currentUser.name}
              </Text>
              <Text ta="center">{currentUser.email}</Text>
            </Paper>
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 8, lg: 9 }}>
            <ProfilePicture />
            <NotificationSettings />
            <ChangePasswordForm />
            <TwoFactorAuth />
            {isStaff && <DevSettings />}
          </Grid.Col>
        </Grid>
      )}
    </LoadOrError>
  );
}

export { Settings };
